import { AppHubCard } from "@/components/common/AppHubCard";
import { AppHubPage } from "@/components/common/AppHubPage";
import { useNav } from "@/utils/nav";
import { createFileRoute } from "@tanstack/react-router";
import { Building2, FileText, Lock, UserRoundCog } from "lucide-react";

const adminItems = [
    {
        title: "Diary records",
        description: "Browse diaries, events, trackers, entries, entry values, templates, and studies.",
        icon: <FileText className="w-7 h-7 text-white" />,
        iconBg: "bg-gradient-to-br from-sky-500 to-sky-600",
        bgGradient: "bg-gradient-to-br from-sky-50 to-sky-50",
        hoverOverlay: "before:bg-gradient-to-br before:from-sky-100/50 before:to-sky-200/50",
        borderColor: "border-sky-200 hover:border-sky-300",
        primaryButtonClassName: "bg-sky-600 hover:bg-sky-700",
        links: [
            { to: "/admin/diaries", label: "Diaries" },
            { to: "/admin/events", label: "Events" },
            { to: "/admin/trackers", label: "Trackers" },
            { to: "/admin/entries", label: "Entries" },
            { to: "/admin/entry-values", label: "Entry values" },
            { to: "/admin/templates", label: "Templates" },
            { to: "/admin/studies", label: "Studies" },
        ],
    },
    {
        title: "Access",
        description: "Control catalogue, form, schedule, and label access, and manage the label list.",
        icon: <Lock className="w-7 h-7 text-white" />,
        iconBg: "bg-gradient-to-br from-amber-500 to-amber-600",
        bgGradient: "bg-gradient-to-br from-amber-50 to-amber-50",
        hoverOverlay: "before:bg-gradient-to-br before:from-amber-100/50 before:to-amber-200/50",
        borderColor: "border-amber-200 hover:border-amber-300",
        primaryButtonClassName: "bg-amber-600 hover:bg-amber-700",
        links: [
            { to: "/admin/access/users", label: "User access" },
            { to: "/admin/access/studies", label: "Study access" },
            { to: "/admin/access/forms", label: "Form access" },
            { to: "/admin/access/schedules", label: "Schedule access" },
            { to: "/admin/access/labels", label: "Label access" },
            { to: "/admin/labels", label: "Labels" },
        ],
    },
    {
        title: "Organisations",
        description: "Add organisations, manage logos, and review usage.",
        icon: <Building2 className="w-7 h-7 text-white" />,
        iconBg: "bg-gradient-to-br from-indigo-500 to-indigo-600",
        bgGradient: "bg-gradient-to-br from-indigo-50 to-indigo-50",
        hoverOverlay: "before:bg-gradient-to-br before:from-indigo-100/50 before:to-indigo-200/50",
        borderColor: "border-indigo-200 hover:border-indigo-300",
        primaryButtonClassName: "bg-indigo-600 hover:bg-indigo-700",
        links: [
            { to: "/admin/organisation/add", label: "Add organisation" },
            { to: "/admin/organisation/logos", label: "Logos" },
            { to: "/admin/organisation/statistics", label: "Statistics" },
        ],
    },
    {
        title: "Support",
        description: "See Patient Watch the way a user or patient does.",
        icon: <UserRoundCog className="w-7 h-7 text-white" />,
        iconBg: "bg-gradient-to-br from-rose-500 to-rose-600",
        bgGradient: "bg-gradient-to-br from-rose-50 to-rose-50",
        hoverOverlay: "before:bg-gradient-to-br before:from-rose-100/50 before:to-rose-200/50",
        borderColor: "border-rose-200 hover:border-rose-300",
        primaryButtonClassName: "bg-rose-600 hover:bg-rose-700",
        links: [
            { to: "/admin/impersonate-user", label: "Impersonate user" },
            { to: "/admin/view-diary-as-patient", label: "Diary as patient" },
        ],
    },
];

const AdminPage = () => {
    useNav([{ label: "Admin", route: { to: "/admin" } }]);

    return (
        <AppHubPage title="Admin" description="Monitor Patient Watch and manage users, organisations, and operations.">
            {adminItems.map((item) => (
                <AppHubCard key={item.title} {...item} />
            ))}
        </AppHubPage>
    );
};

export const Route = createFileRoute("/_app/admin/")({
    component: AdminPage,
});
